// extracted by mini-css-extract-plugin
export default {"title":"UWSection_title__e9BKO","section":"UWSection_section__RR6WI"};